export default import.meta.ROLLDOWN_FILE_URL_r31_BrIpXQObrZugsc5Rjw